{{formattedFrequency}}<ng-content />
